<template>
	<div :class="sideOverShow ? 'side-over--active' : ''">
		<div
			v-if="sideOverShow"
			class="
				fixed
				h-screen
				w-screen
				top-0
				left-0
				bg-black
				opacity-20
				z-30
			"
			@click="sideOverShow = false"
		></div>
		<GoalDetail
			@close="sideOverShow = false"
			:sideOverShow="sideOverShow"
			:goalId="goalId"
			:studentId="studentId"
		/>
	</div>
	<div>
		<div class="font-semibold text-lg text-neutral-600 mb-4">
			{{ index + 1 }}. {{ data?.skill?.name }} ({{
				(data?.goals ?? data.goals_group_by_skill)?.length
			}})
		</div>
		<div class="shadow-sm sm:rounded-2xl overflow-hidden">
			<div class="__record__table overflow-x-auto scroll-bar">
				<div class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full">
					<table class="min-w-full divide-y text-neutral-200">
						<thead class="bg-neutral-100 h-16">
							<tr>
								<th
									class="
										px-6
										py-3
										text-left text-xs
										font-semibold
										text-neutral-600
										uppercase
										tracking-wider
										w-16
										whitespace-nowrap
									"
									scope="col"
								>
									STT
								</th>
								<th
									class="
										px-6
										py-3
										text-left text-xs
										font-semibold
										text-neutral-600
										uppercase
										tracking-wider
										whitespace-nowrap
									"
									scope="col"
									style="min-width: 160px"
								>
									NỘI DUNG
								</th>
								<th
									class="
										px-6
										py-3
										text-left text-xs
										font-semibold
										text-neutral-600
										uppercase
										tracking-wider
										whitespace-nowrap
									"
									scope="col"
								>
									chỉnh sửa cuối
								</th>
								<th
									class="
										px-6
										py-3
										text-left text-xs
										font-semibold
										text-neutral-600
										uppercase
										tracking-wider
										whitespace-nowrap
									"
									scope="col"
								>
									Người tạo
								</th>
							</tr>
						</thead>
						<tbody>
							<template
								v-for="(g, i) in data?.goals"
								:key="g.goal_id || g.id"
							>
								<tr
									:class="
										i % 2 === 0
											? 'bg-white'
											: 'bg-neutral-50'
									"
									class="text-neutral-700 cursor-pointer"
								>
									<td
										class="
											px-6
											py-4
											whitespace-nowrap
											text-neutral-700 text-center
										"
									>
										{{ i + 1 }}
									</td>
									<td class="px-6 py-4 text-neutral-700">
										<div class="flex items-center">
											<div
												class="
													mr-2
													hover:text-yellow-700
													hover:underline
												"
												@click.stop="openGoalDetail(g)"
												v-html="g.goal_name || g.name"
											></div>
											<TooltipGoalDetail
												:goal-id="g.goal_id || g.id"
												:is-group="isGroup"
												:student-id="
													studentId.toString()
												"
											/>
										</div>
										<div
											class="flex gap-2 flex-wrap"
											style="max-width: 360px"
										>
											<div
												v-if="g?.source"
												class="
													mt-1
													py-0.5
													px-2.5
													rounded-full
													bg-neutral-200
													text-neutral-700
													h-fit
													w-fit
													font-semibold
													shadow-input
													whitespace-nowrap
												"
												style="font-size: 10px"
											>
												{{ g?.source }}
											</div>
											<div
												v-else
												class="
													mt-1
													py-0.5
													px-2.5
													rounded-full
													bg-neutral-200
													text-neutral-700
													h-fit
													w-fit
													font-semibold
													shadow-input
													whitespace-nowrap
												"
												style="font-size: 10px"
											>
												{{
													$filters.sourceMap(
														g?.state,
														g.editable
													)
												}}
											</div>
											<template
												v-if="
													g?.assistance_levels &&
													org.enable_goal_assistance_level
												"
											>
												<div
													v-for="ass in g?.assistance_levels"
													:key="ass"
													class="flex gap-2"
												>
													<div
														class="
															mt-1
															py-0.5
															px-2.5
															rounded-full
															bg-pink-100
															whitespace-nowrap
															text-neutral-700
															h-fit
															w-fit
															font-semibold
															shadow-input
														"
														style="font-size: 10px"
													>
														{{ ass }}
													</div>
												</div>
											</template>
											<div
												class="
													mt-1
													py-0.5
													px-2.5
													rounded-full
													bg-yellow-tag
													text-neutral-700
													h-fit
													w-fit
													font-semibold
													shadow-input
													whitespace-nowrap
												"
												style="font-size: 10px"
												v-if="g?.age"
											>
												{{ g?.age }}
											</div>
										</div>
										<div
											v-if="g.parent?.sub_goal_count > 0"
											class="goal-block flex gap-3 mt-2"
										>
											<img
												class="w-3 h-3 mt-1"
												src="@/assets/images/icons/goal-arrow.png"
												alt=""
											/>
											<div>
												<div class="text-neutral-700">
													{{ g.parent?.name }}
												</div>
												<div
													class="
														text-neutral-400 text-xs
														font-semibold
													"
												>
													{{
														g.parent?.sub_goal_count
													}}
													MỤC TIÊU
												</div>
											</div>
										</div>
									</td>
									<td class="px-6 py-4 text-neutral-700">
										<div>
											<div
												v-if="g.updated_by_staff"
												class="flex items-center mb-4"
											>
												<div>
													<img
														v-if="
															g.updated_by_staff
																?.profile_photo
																?.w200
														"
														:src="
															g.updated_by_staff
																?.profile_photo
																?.w200
														"
														alt=""
														class="
															shadow-sm
															inline-block
															h-9
															w-9
															rounded-full
														"
													/>
													<span
														v-else
														:style="{
															background:
																g
																	.updated_by_staff
																	?.profile_photo
																	?.default
																	?.color,
														}"
														class="
															inline-flex
															items-center
															justify-center
															h-9
															w-9
															rounded-full
														"
													>
														<span
															class="
																font-medium
																leading-none
																text-white
																text-xs
															"
															>{{
																g
																	.updated_by_staff
																	?.profile_photo
																	?.default
																	?.initial
															}}</span
														>
													</span>
												</div>
												<div
													class="
														ml-4
														text-blue-600
														font-semibold
														truncate
													"
												>
													{{
														g.updated_by_staff.name
													}}
												</div>
											</div>
											<div v-if="g.last_updated_at">
												{{
													$filters.formatDateTime(
														g.last_updated_at
													)
												}}
											</div>
										</div>
									</td>
									<td class="px-6 py-4 text-neutral-700">
										<div>
											<div
												v-if="g.created_by_staff"
												class="flex items-center mb-4"
											>
												<div>
													<img
														v-if="
															g.created_by_staff
																?.profile_photo
																?.w200
														"
														:src="
															g.created_by_staff
																?.profile_photo
																?.w200
														"
														alt=""
														class="
															shadow-sm
															inline-block
															h-9
															w-9
															rounded-full
														"
													/>
													<span
														v-else
														:style="{
															background:
																g
																	.created_by_staff
																	?.profile_photo
																	?.default
																	?.color,
														}"
														class="
															inline-flex
															items-center
															justify-center
															h-9
															w-9
															rounded-full
														"
													>
														<span
															class="
																font-medium
																leading-none
																text-white
																text-xs
															"
															>{{
																g
																	.created_by_staff
																	?.profile_photo
																	?.default
																	?.initial
															}}</span
														>
													</span>
												</div>
												<div
													class="
														ml-4
														text-blue-600
														font-semibold
														truncate
													"
												>
													{{
														g.created_by_staff.name
													}}
												</div>
											</div>
											<div v-if="g.inserted_at">
												{{
													$filters.formatDateTime(
														g.inserted_at
													)
												}}
											</div>
										</div>
									</td>
								</tr>
							</template>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TooltipGoalDetail from '@/components/elements/tooltipGoalDetail/TooltipGoalDetail.vue';
import GoalDetail from '@/views/goal/GoalDetail.vue';

export default {
	name: 'GoalListFull',
	components: { TooltipGoalDetail, GoalDetail },

	props: {
		index: {
			type: Number,
			required: true,
		},

		isGroup: {
			type: Boolean,
			default: false,
		},

		data: {
			type: Object,
			required: true,
		},

		studentId: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			sideOverShow: false,
			goalId: null,
		};
	},
	computed: {
		org() {
			return this.$store.state.profile.current_org;
		},
	},
	methods: {
		openGoalDetail(item) {
			this.sideOverShow = true;
			this.goalId = item.goal_id || item.id;
		},
	},
};
</script>

<style scoped>
.goal-block {
	background: #eef3f8;
	padding: 12px;
	border-radius: 8px;
	border: 1px solid #bacde4;
}
</style>
